module.exports = __webpack_public_path__ + "media/images/lp/ashinagasan-ad1/img_lp-data__box-img04-ff025f31abc900900040bb9dd6113655.png";